module.exports = {"id":"186274","name":"Konstantin Rausch","rating":"72","photo":"./data/images/photos/1/186274.png","club":{"name":"Dynamo Moscou","logo":"./data/images/clubs/DynamoMoscou.png"},"positions":["DG","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KonstantinRausch0.json
// module id = 2397
// module chunks = 0